import { render } from "./achievement-list.vue?vue&type=template&id=0d4f947a&scoped=true"
import script from "./achievement-list.vue?vue&type=script&lang=js"
export * from "./achievement-list.vue?vue&type=script&lang=js"

import "./achievement-list.vue?vue&type=style&index=0&id=0d4f947a&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d4f947a"]])

export default __exports__